import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('text', {
        label: 'Text',
        category: blockCategories.basic,
        content: {
            type: 'text',
            content: 'Insert your text here',
            classes: 'sio-text',
        },
        media: `<svg fill="currentColor" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="font" class="svg-inline--fa fa-font fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"></path></svg>`,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const textType = domComponents.getType('text');
    const textView = textType.view;

    domComponents.addType('text', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Text',
                tagName: 'div',
                droppable: true,
                editable: true,
            }),
        },
        view: textView,
    });

    blockManager.add('span', {
        label: 'Inline-Text',
        category: blockCategories.basic,
        content: {
            type: 'span',
            content: 'Insert your text here',
            classes: 'sio-span',
        },
        media: `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <text x="12" y="20" font-size="24" font-weight="bold" text-anchor="middle" fill="currentColor">T</text>
        </svg>`,
    });


    domComponents.addType('span', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Span',
                tagName: 'span',
                droppable: false,
                editable: true,
            }),
        },
        view: textView,
    });
};
